const OilChangeType = {
  dieselMonoGrade: "diesel-monograde",
  dieselMultiGrade: "diesel-multigrade",
  dieselFullySynthetic: "diesel-fully-synthetic",
  dieselTerraSportFullySynthetic: "diesel-terra-sport-fully-synthetic",
  gasolineMonoGrade: "gasoline-monograde",
  gasolineMultiGrade: "gasoline-multigrade",
  gasolineFullySynthetic: "gasoline-fully-synthetic",
  gasolineFullySynthetic5W40: "gasoline-fully-synthetic-5w-40",
  gasolineTerraSportFullySynthetic: "gasoline-terra-sport-fully-synthetic",
  terraSportFullySynthetic: "terra-sport-fully-synthetic",
};

export default OilChangeType;
